import { useEffect } from 'react'
// redux
import { useSelector } from 'react-redux'
// route
import { useLocation } from 'react-router-dom'
// library
import dayjs from '../utils/dayjs-config'
// Query
import { useContentfulMetrics } from './contentful'
// services
import TrackingServices from 'services/tracking'
import AuthService from 'modules/Auth/services/auth'
// constants
import storageNames from 'constants/storageNames'

// route need location.pathname from useLocation() in react-route
///
/// Nota: In routes sat 'campaign' to init the process
/// example // http://localhost:3000/home?campaign=prueba&services=prueba
///
export default function useMetrics() {
	// router
	const { pathname: route, search } = useLocation()
	const allSearch = new URLSearchParams(search)
	const getCampaign = allSearch.get('campaign') || false
	const getServices = allSearch.get('services') || false

	// data of contentFull
	const { metricContent } = useContentfulMetrics()

	// redux
	const {
		session: { email, userWithoutLogin, isLogin },
		activePatient: { userId }
	} = useSelector(state => state)

	// time
	const currentTime = dayjs().format('YYYY/MM/DD HH:mm:ss')

	// vars
	const payloadData = JSON.parse(localStorage.getItem(storageNames.campaignData)) || {
		service: getServices,
		campaign: getCampaign
	}
	let actionTracking = localStorage.getItem(storageNames.actionTracking)
		? parseInt(localStorage.getItem(storageNames.actionTracking))
		: null
	const intoCampaign = localStorage.getItem(storageNames.intoCampaign) === 'true'

	// list // this will be called from ContentFull
	const trackingList =
		(localStorage.getItem(storageNames.metricContentCampaign) &&
			JSON.parse(localStorage.getItem(storageNames.metricContentCampaign)).trackingList) ||
		(metricContent && metricContent.trackingList)
	const campaignList =
		(localStorage.getItem(storageNames.metricContentCampaign) &&
			JSON.parse(localStorage.getItem(storageNames.metricContentCampaign)).campaignList) ||
		(metricContent && metricContent.campaignList)

	// send data
	const handleSendTracking = ({
		admission = null,
		services = null,
		finish = null,
		service = null
	}) => {
		const payload = {
			userId,
			actionTrakingId: actionTracking,
			campaign: payloadData.campaign,
			suggestedService: payloadData.service,
			service,
			admissionDate: admission,
			serviceDate: services,
			finishNavigationDate: finish
		}

		if (userWithoutLogin) payload.email = email

		return TrackingServices.handleTracking({ userId, payload }).then(res => {
			if (res.status === 200) {
				if (finish === null) {
					const id = res.data.actionTrakingId
					!finish && localStorage.setItem(storageNames.actionTracking, id)
				}
			}
		})
	}

	// listener  first call
	const handledRoute = () => {
		localStorage.setItem(storageNames.intoCampaign, true)
		handleSendTracking({ services: currentTime })
	}

	// finish last call
	const handledFinish = async () => {
		await handleSendTracking({
			finish: currentTime,
			service: payloadData.service
		})
		localStorage.removeItem(storageNames.intoCampaign)
		localStorage.removeItem(storageNames.actionTracking)
		actionTracking = null
	}

	// const get init Url
	const initUrl = () => {
		const setCampaignData = {
			service: getCampaign,
			campaign: getServices
		}

		localStorage.setItem(storageNames.campaignData, JSON.stringify(setCampaignData))
	}

	useEffect(() => {
		if (!metricContent) return
		if (metricContent?.campaignList?.length === 0 || metricContent?.trackingList?.length === 0)
			return

		localStorage.setItem(storageNames.metricContentCampaign, JSON.stringify(metricContent))
	}, [metricContent])

	useEffect(() => {
		if (
			isLogin &&
			AuthService.isLoggedIn(true) &&
			trackingList?.length > 0 &&
			campaignList?.length > 0
		) {
			const inHome = trackingList?.some(list => list === route)
			const inCampaign = campaignList?.some(list => list === route)

			if (getCampaign) {
				initUrl()

				if (!intoCampaign && (inHome || inCampaign)) {
					return handledRoute()
				}
			}

			intoCampaign && actionTracking && handledFinish()
		}
	}, [route])
}
